import {
	ChatBubbleLeftIcon,
	ClockIcon,
	EyeSlashIcon,
	GlobeAltIcon,
	HandThumbUpIcon,
	HomeModernIcon,
	LightBulbIcon,
	ScaleIcon,
	ShieldCheckIcon,
	UserGroupIcon,
} from '@heroicons/react/24/outline';
import client from './api/client';

export const getKeywords = async () => {
	const { data } = await client.get('/admin/keywords');
	return data.keywords.map((keyword) => keyword.word);
};

const keywordArray = await getKeywords();
console.log({ keywordArray });

const companyName = 'USA Blinds';
const domain = 'usablinds.us';
let seo = {
	companyName,
	company: {
		name: companyName,
		phone: '(850) 533-5366',
		email: `contact@${domain}`,
		address: {
			street: '4400 Bayou Blvd Ste 46-A',
			city: 'Pensacola',
			state: 'FL',
			zip: '32503',
			country: 'USA',
		},
	},
	missionStatement: [
		'To be the trusted partner for homeowners, designers, and builders for window treatment solutions, setting the standard for customer experience and style',
	],
	story: [
		'USA Blinds was founded to serve the Gulf Coast community by offering premier  window treatment solutions tailored to local homeowners, designers, and real estate investors. With a deep understanding of the importance of enhancing home value and style, we partner with clients to create spaces that are both beautiful and functional. Our roots in the region drive our commitment to delivering exceptional service and lasting solutions that reflect the unique character of every home and investment.',
		'Our mission is to provide high-quality, stylish window treatments that deliver exceptional value. By offering a thoughtfully curated selection of products, we prioritize what matters most to our clients: quality, affordability, and style.  Committed to delivering an unparalleled customer experience from consultation to installation, we make high-quality window solutions accessible, ensuring that every customer enjoys the beauty and functionality of their home investment.',
	],
	site: {
		title: `${companyName} | USA Blinds`,
		description: `Offering premium interior blinds for new construction and remodeling projects across Southern Alabama and the Northwest Florida panhandle. Contact us for a consultation today!`,

		url: `https://${domain}`,
		keywords: await keywordArray
			.map((keyword) => {
				return keyword.trim();
			})
			.join(', '),
		viewport: 'width=device-width, initial-scale=1.0',
	},
	location_language: {
		region: 'US-FL',
		language: 'en-US',
		placename: 'Pensacola',
		position: '30.4581° N, 87.2170° W',
	},
	img: {
		favicon: `https://${domain}/favicon.ico`,
		twitter: `https://${domain}/logos/logo.png`,
	},
	social: {
		twitter: {
			username: '@usa_blinds',
			url: '#',
		},
		googleBiz: {
			username: '@usa_blinds',
			url: '#',
		},
		linkedIn: {
			username: '@usa_blinds',
			url: '#',
		},
	},
	dev: {
		twitter: {
			username: '@andrewkeiser_',
			url: 'https://twitter.com/andrewkeiser_',
		},
	},
};
seo = {
	...seo,
	social: {
		...seo.social,
		nav: [
			// {
			// 	name: 'Facebook',
			// 	href: '#',
			// 	icon: (props) => (
			// 		<svg
			// 			fill='currentColor'
			// 			viewBox='0 0 24 24'
			// 			{...props}
			// 		>
			// 			<path
			// 				fillRule='evenodd'
			// 				d='M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z'
			// 				clipRule='evenodd'
			// 			/>
			// 		</svg>
			// 	),
			// },
			// 			{
			// 				name: 'Google Business Listing',
			// 				href: '#',
			// 				icon: (props) => (
			// 					<svg
			// 						fill='currentColor'
			// 						viewBox='0 0 24 24'
			// 						{...props}
			// 					>
			// 						<path d='M21.35 11.1h-9.43v2.89h5.42c-.24 1.27-.92 2.35-1.92 3.07v2.54h3.1c1.8-1.66 2.83-4.12 2.83-7 0-.46-.03-.91-.1-1.35z' />
			// 						<path d='M12 22c2.7 0 4.96-.9 6.62-2.42l-3.1-2.54c-.82.54-1.86.86-3.02.86-2.32 0-4.3-1.57-5.01-3.68H4.3v2.3C5.94 19.8 8.78 22 12 22z' />
			// 						<path d='M6.99 13.22c-.19-.55-.31-1.13-.31-1.72s.11-1.17.31-1.72V7.48H4.3C3.47 8.78 3 10.33 3 11.99s.47 3.21 1.3 4.51l2.69-2.28z' />
			// 						<path d='M12 5.54c1.27 0 2.41.44 3.31 1.3l2.46-2.46C16.96 3.23 14.7 2 12 2 8.78 2 5.94 4.2 4.3 7.48l2.69 2.3c.71-2.11 2.69-3.68 5.01-3.68z' />
			// 					</svg>
			// 				),
			// 			},
			//
			// 			{
			// 				name: 'LinkedIn',
			// 				href: seo.social.linkedIn.url,
			// 				icon: (props) => (
			// 					<svg
			// 						fill='currentColor'
			// 						viewBox='0 0 64 64'
			// 						{...props}
			// 					>
			// 						<path
			// 							d='M30,60 C46.5685433,60 60,46.5685433 60,30 C60,13.4314567 46.5685433,0 30,0 C13.4314567,0 0,13.4314567 0,30 C0,46.5685433 13.4314567,60 30,60 Z'
			// 							fill='currentColor'
			// 							id='Linkedin'
			// 						/>
			// 						<path
			// 							d='M21.8830754,43.8231512 L21.8830754,25.5243389 L16.22737,25.5243389 L16.22737,43.8231512 L21.8830754,43.8231512 Z M21.8830754,19.0382145 C21.8493882,17.40066 20.7580156,16.1538462 18.9850543,16.1538462 C17.2116316,16.1538462 16.0528846,17.40066 16.0528846,19.0382145 C16.0528846,20.6402023 17.1779444,21.9230769 18.9172185,21.9230769 L18.9509057,21.9230769 C20.7580156,21.9230769 21.8830754,20.6402023 21.8830754,19.0382145 Z M31.1100418,43.8231517 L31.1100418,33.3973729 C31.1100418,32.8394014 31.1503704,32.28143 31.3144472,31.8836682 C31.7630341,30.7682778 32.7839561,29.6136637 34.498199,29.6136637 C36.7438958,29.6136637 38.152278,30.8881587 38.152278,33.3973727 L38.152278,43.8231516 L43.8461538,43.8231517 L43.8461538,33.1183872 C43.8461538,27.3839878 40.7850453,24.715669 36.7019099,24.715669 C33.3540813,24.715669 31.8845724,26.5873593 31.0686083,27.861302 L31.1094893,25.4139123 L25.425462,25.4139123 C25.5072241,27.1657215 25.425462,43.8231516 25.425462,43.8231516 L31.1100418,43.8231517 Z'
			// 							// fill='currentColor'
			// 							fill='#FFFFFF'
			// 						/>
			// 					</svg>
			// 				),
			// 			},
		],
	},
};
export const values = [
	{
		name: 'Integrity and Trust',
		description: '',
		href: '#',
		icon: ScaleIcon,
	},
	{
		name: 'Customer Focused',
		description: '',
		href: '#',
		icon: UserGroupIcon,
	},
	{
		name: 'Curated Elegance',
		description: '',
		href: '#',
		icon: GlobeAltIcon,
	},
	{
		name: 'Resourcefulness',
		description: '',
		href: '#',
		icon: LightBulbIcon,
	},
];

export const services = [
	{
		name: 'Professional Installations',
		description:
			'Specializing in window treatments for new homes, remodels, and multifamily projects. We ensure every installation is seamless and enhances your space.',
		icon: HomeModernIcon,
	},

	{
		name: 'Professional Consultation',
		description:
			'Our team provides expert guidance tailored to your style, helping you select the perfect blinds for each room.',
		icon: ChatBubbleLeftIcon,
	},
	{
		name: 'Efficient, Reliable Service',
		description:
			'We value your time and guarantee a streamlined installation process, meeting project deadlines with exceptional quality.',
		icon: ClockIcon,
	},

	{
		name: 'Satisfaction Guaranteed',
		description:
			'We’re committed to delivering a flawless result, ensuring you’re fully satisfied with your new blinds and installation experience.',
		icon: HandThumbUpIcon,
	},
];

export default seo;
